import { useEffect, useRef } from "react";
import gsap from "gsap";

interface LoadScreenProps {
  onDone: () => void;
}

/**
 * Simple deterministic 2-second load reveal. Progress bar sweeps 0→100 in ~1.6s, then a 400ms fade-in of the scene.
 */
export function LoadScreen({ onDone }: LoadScreenProps) {
  const rootRef = useRef<HTMLDivElement>(null);
  const barRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!barRef.current || !rootRef.current) return;
    const tl = gsap.timeline({ onComplete: onDone });
    tl.fromTo(barRef.current, { scaleX: 0 }, { scaleX: 1, duration: 1.6, ease: "power2.inOut" });
    tl.to(rootRef.current, { opacity: 0, duration: 0.4, ease: "power2.out", pointerEvents: "none" }, "-=0.05");
    return () => {
      tl.kill();
    };
  }, [onDone]);

  return (
    <div
      ref={rootRef}
      className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-background-950"
      style={{ background: "#1A1816" }}
    >
      <div className="flex flex-col items-center gap-8 select-none">
        {/* Vessel icon */}
        <div className="w-14 h-14 flex items-center justify-center">
          <i className="ri-goblet-2-line" style={{ fontSize: "42px", color: "#D4A574" }} />
        </div>
        <p
          className="font-mono-caps text-foreground-100"
          style={{ letterSpacing: "0.32em", fontSize: "13px" }}
        >
          POTTERY MAKING
        </p>
        <div className="w-[220px] h-px bg-background-800 overflow-hidden">
          <div
            ref={barRef}
            className="h-full origin-left"
            style={{ background: "#D4A574", transform: "scaleX(0)" }}
          />
        </div>
        <p className="font-mono-caps text-[10px] text-foreground-500">Warming the wheel</p>
      </div>
    </div>
  );
}